import logoDragon from '@/assets/logo-insane-force-dragon.jpg';

export function Footer() {
  return (
    <footer className="relative py-4 md:py-6 border-t border-white/10 overflow-hidden text-white" style={{
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 50%, #1f1f1f 100%)'
    }}>
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        {/* Logo circular más pequeño */}
        <div className="relative inline-block mb-4 md:mb-6">
          <div className="relative w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden ring-1 ring-accent/15 shadow-lg">
            <img 
              src={logoDragon} 
              alt="Insane Force Team" 
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        
        {/* Línea decorativa más sutil */}
        <div className="flex items-center justify-center gap-3 mb-3 md:mb-4">
          <div className="h-px w-6 md:w-8 bg-gradient-to-r from-transparent to-accent/40"></div>
          <div className="w-1 h-1 bg-accent/50 rotate-45"></div>
          <div className="h-px w-6 md:w-8 bg-gradient-to-l from-transparent to-accent/40"></div>
        </div>
        
        <p className="text-[9px] md:text-[10px] font-medium uppercase tracking-[0.2em] md:tracking-[0.3em] text-white/60">
          Powered by Insane Force © 2026 Insane Force. Todos los derechos reservados. Marca Registrada ®
        </p>
      </div>
    </footer>
  );
}